// Simple Ghost API connection test tool

// Function to test connection with a given URL and key
export const testGhostConnection = async (url, key) => {
  try {
    console.log(`Testing connection to Ghost at: ${url}`);
    
    // Simple fetch request to the API
    const endpoint = `${url}/ghost/api/content/v5.0/posts/?key=${key}&limit=1`;
    console.log(`Sending request to: ${endpoint}`);
    
    const response = await fetch(endpoint);
    
    // Log full response
    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error response:', errorText);
      return {
        success: false,
        status: response.status,
        message: `Request failed with status: ${response.status}`,
        details: errorText
      };
    }
    
    const data = await response.json();
    console.log('Response data:', data);
    
    return {
      success: true,
      status: response.status,
      message: `Successfully connected to Ghost at ${url}`,
      posts: data.posts || []
    };
  } catch (error) {
    console.error('Connection test error:', error);
    return {
      success: false,
      message: error.message,
      error
    };
  }
};

// Export a function to run from the browser console
export const testGhost = async (url, key) => {
  url = url || process.env.REACT_APP_GHOST_URL;
  key = key || process.env.REACT_APP_GHOST_CONTENT_API_KEY;
  
  console.log('Ghost API Test');
  console.log('==============');
  console.log('URL:', url);
  console.log('Key:', key ? `${key.substring(0, 4)}...${key.substring(key.length - 4)}` : 'Not provided');
  
  const result = await testGhostConnection(url, key);
  console.log('==============');
  console.log('Test Result:', result.success ? 'SUCCESS' : 'FAILED');
  console.log('Message:', result.message);
  
  return result;
};

// For use in browser console
window.testGhost = testGhost;

export default {
  testGhostConnection,
  testGhost
}; 